module.exports = __webpack_public_path__ + "static/media/man-stand.8ffa8020.svg";